import { styled } from 'solid-styled-components';
import theme from '../../../style/theme';

export const StyledMenuMobile = styled.div`
    padding-inline: ${theme.grid.gapSizeMobile}rem;
    padding-top: 0;
    padding-bottom: 0;
    z-index: 10;
    overflow-y: scroll;
    overflow-x: hidden;

    ${theme.mediaQueries.mobileMax} {
        padding: ${theme.grid.mobileColumnGap}rem;
        padding-top: 0;
        padding-bottom: 0;
    }
`;

